import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const DATEADD = () => {
  return (
    <CardSection id="DATEADD" title="DATEADD">
      <Paragraph>
        주어진 날짜로부터 특정 시간 혹은 기간이 지난 날짜를 계산합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>DATEADD(DATETIME, INCREMENT, INTERVAL)</Paragraph>
        <Ul>
          <Li>
            <b>DATETIME</b>은 계산을 위한 기준 날짜입니다.
          </Li>
          <Li>
            <b>INCREMENT</b>는 <b>DATETIME</b>에 추가하기 위한 숫자 값입니다.
          </Li>
          <Li>
            <b>INTERVAL</b>은 추가할 간격(분, 일, 년 등)입니다. 다음은{" "}
            <b>INTERVAL</b>에 대해 인식되는 값 목록입니다.
            <Ul>
              <Li>Years</Li>
              <Li>Months</Li>
              <Li>Weeks</Li>
              <Li>Days</Li>
              <Li>Hours</Li>
              <Li>Minutes</Li>
              <Li>Seconds</Li>
              <Li>Millis</Li>
            </Ul>
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>DATEADD(`Date-Received`, 6, "months")</Paragraph>
        <Img src="computeDateadd" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>DATETIME</b>은 날짜/시간 객체 혹은 날짜/시간 객체를
          포함하는 열 또는 날짜/시간 객체를 반환하는 함수여야 합니다. 제공된{" "}
          <b>INCREMENT</b>는 <b>정수</b>여야 합니다. Millis는 최대 +/-
          2147483647을 허용합니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
